import { usePostEventMutation } from '@carboncopyco/data';
import {
  EventAction,
  EventTarget,
  type IPresentation,
} from '@carboncopyco/types';
import type { PreviewData } from '../PresentationModals/GiveADemoModal';
import type { DemoPageProps } from './DemoPage/DemoPageContext';

type Props = {
  presentation: IPresentation;
  organizationId: string;
  goToDemoPreview: DemoPageProps['goToDemoPreview'];
  from?: PreviewData['from'];
};

export const usePresentationPreview = ({
  presentation,
  organizationId,
  goToDemoPreview,
  from,
}: Props) => {
  const [postEvent] = usePostEventMutation();

  return async () => {
    const { forClient, playerToken, workspaceId } = presentation;
    const previewData = {
      playerToken,
      client: forClient,
      ...(from ? { from } : {}),
    };

    previewData['presentationPreviewId'] = presentation.id;

    postEvent({
      organizationId,
      workspaceId,
      presentationId: String(presentation.id),
      action: EventAction.PREVIEWED,
      target: EventTarget.PRESENTATION,
    });
    goToDemoPreview({
      previewData,
      presentationId: presentation?.id,
      presentation,
    });
  };
};
